import store from '@/store'

export default class CardApi {
  static async voteCard (payload) {
    return await store.dispatch('workflow/toggleCardReaction', payload)
  }
}
